import Fornecedor from './componentes/Fornecedor.vue';
import Alterar from './componentes/Alterar.vue';
import ContratoLista from './componentes/ContratoLista.vue';
import SolicitacaoPesquisaPrecoLista from './componentes/SolicitacaoPesquisaPrecoLista.vue';
import PesquisaPrecoLista from './componentes/PesquisaPrecoLista.vue';

export default {
  path: 'fornecedor',
  component: Fornecedor,
  meta: { auth: true },
  children: [
    {
      path: 'alterar',
      name: 'fornecedor.alterar',
      component: Alterar,
    },
    {
      path: 'contrato',
      name: 'fornecedor.contrato',
      component: ContratoLista,
    },
    {
      path: 'solicitacao-pesquisa-preco',
      name: 'fornecedor.solicitacao-pesquisa-preco',
      component: SolicitacaoPesquisaPrecoLista,
    },
    {
      path: 'solicitacao-pesquisa-preco/:id',
      name: 'fornecedor.pesquisa-preco',
      component: PesquisaPrecoLista,
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/fornecedor/rotas.js